import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'

const BASE_PATH = '/lottustech/configuracoesBoletos'
const crud = build(validate, BASE_PATH)
const prefix = 'crudConfiguracaoBoleto'

const newTypes = {
  RESET: `${prefix}reset`,
  SET_BOOLEAN_FILTER: `${prefix}setBooleanFilter`,
}

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.reset = () => {
  return {
    type: types.RESET,
  }
}

actions.setBooleanFilter = (field, value) => {
  return {
    type: types.SET_BOOLEAN_FILTER,
    field,
    value,
  }
}

export { types, actions }
